/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_TitleInputs */

const vi_aroma_sampling_title = /** @type {(inputs: Aroma_Sampling_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy hương chè`)
};

/**

* @param {Aroma_Sampling_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_title = /** @type {((inputs?: Aroma_Sampling_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_title(inputs)
});